const SELECT_KEY = /* @__PURE__ */ Symbol();
export {
  SELECT_KEY
};
//# sourceMappingURL=type.js.map
